import React from "react";
import "../../../css/ContactInfoSection.css";
import { ReactComponent as PhoneIcon } from "../../../assets/icons/Contact.svg";
import { ReactComponent as EmailIcon } from "../../../assets/icons/email.svg";

const ContactInfoSection = () => (
  <div className="about-section">
    <div className="about-section-content">
      <section className="contact-info-section">
        <div className="contact-info-row">
          <div className="contact-info-left">
            <div className="contact-info-item">
              <PhoneIcon className="contact-icon phone-icon" />
              <span className="subtitle-bold primary">0330 223 7717</span>
            </div>
            <div className="contact-info-item">
              <EmailIcon className="contact-icon email-icon" />
              <a
                className="subtitle-bold primary"
                href="mailto:info@edwardcoombs.co.uk"
              >
                info@edwardcoombs.co.uk
              </a>
            </div>
          </div>
          <div className="contact-info-divider" />
          <div className="contact-info-right">
            <div className="contact-info-details">
              <div className="content primary" style={{ marginBottom: "20px" }}>
                If you are not happy with our service, please write to
                Complaints Officer, Rosemount Financial Solutions (IFA) Ltd,
                Rosemount House, 2-4 Chequers Road, Basingstoke, RG21 7PU.
                Telephone{" "}
                <a
                  href="tel:01256405460"
                  style={{
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    textDecoration: "none",
                    color: "inherit",
                    fontWeight: "bold",
                  }}
                >
                  01256 405460
                </a>{" "}
                or e-mail{" "}
                <a
                  href="mailto:complaints@rosemountfs.co.uk"
                  style={{
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    textDecoration: "none",
                    color: "inherit",
                    fontWeight: "bold",
                  }}
                >
                  complaints@rosemountfs.co.uk
                </a>
                .
              </div>
              <div className="content primary">
                A summary of our internal complaints handling procedures for the
                reasonable and prompt handling of complaints is available on
                request and if you cannot settle your complaint with us, you may
                be entitled to refer it to the financial Ombudsman Service at
                {" "}
                <a
                  href="https://www.financial-ombudsman.org.uk"
                  style={{
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    textDecoration: "none",
                    color: "inherit",
                    fontWeight: "bold",
                  }}
                >
                  www.financial-ombudsman.org.uk
                </a>{" "}
                or by contacting them on{" "}
                <a
                  href="tel:08000234567"
                  style={{
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    textDecoration: "none",
                    color: "inherit",
                    fontWeight: "bold",
                  }}
                >
                  0800 023 4567
                </a>
                .
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
);

export default ContactInfoSection;
